{
  "PROFILE_SETTINGS": {
    "LINK": "Postavke profila",
    "TITLE": "Postavke profila",
    "BTN_TEXT": "Ažuriraj profil",
    "DELETE_AVATAR": "Izbriši avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar has been deleted successfully",
    "AVATAR_DELETE_FAILED": "There is an error while deleting avatar, please try again",
    "UPDATE_SUCCESS": "Your profile has been updated successfully",
    "PASSWORD_UPDATE_SUCCESS": "Your password has been changed successfully",
    "AFTER_EMAIL_CHANGED": "Your profile has been updated successfully, please login again as your login credentials are changed",
    "FORM": {
      "PICTURE": "Profilna slika",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Изображение за подпис на имейл",
        "HINT": "Използва се в подписите на имейли. {'{{'}email_signature_picture{'}}'} се заменя с URL адреса на това изображение (а не с таг за изображение) — използвайте го като източник на изображение (атрибута src на img таг) във вашия подпис или подписа на пощенската кутия. Ако не е зададено, нищо не се вмъква.",
        "DELETE_SUCCESS": "Изображението за подпис на имейл беше изтрито успешно",
        "DELETE_FAILED": "Възникна грешка при изтриване на изображението за подпис на имейл, моля, опитайте отново"
      },
      "AVATAR": "Profilna slika",
      "ERROR": "Please fix form errors",
      "REMOVE_IMAGE": "Izbriši",
      "UPLOAD_IMAGE": "Prenesi sliku",
      "UPDATE_IMAGE": "Ažuriraj sliku",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Your email address is your identity and is used to log in."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey to send messages",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Your settings have been updated successfully",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Персонализирайте облика на таблото си.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Jezik kontrolne ploče",
          "NOTE": "Nadjačaj jezik računa za vlastitu kontrolnu ploču. Ostavite prazno za korištenje zadanog jezika računa.",
          "USE_ACCOUNT_DEFAULT": "Koristi zadani jezik računa",
          "API_SUCCESS": "Jezik vaše kontrolne ploče je uspješno ažuriran",
          "API_ERROR": "Došlo je do greške pri ažuriranju jezika kontrolne ploče, pokušajte ponovno"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Jezik poruka",
          "NOTE": "Odaberite želite li prikazati izvorne poruke ili njihove prijevode",
          "ORIGINAL": "Izvorno",
          "TRANSLATED": "Prevedeno"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Ponašanje lijepljenja",
          "NOTE": "Odaberite kako treba obraditi zalijepljeni sadržaj pri sastavljanju poruka",
          "UPDATE_SUCCESS": "Postavke lijepljenja uspješno ažurirane",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Sačuvaj svo oblikovanje",
              "DESCRIPTION": "Sačuvaj svo oblikovanje uključujući tablice, stilove i ostale HTML elemente pri lijepljenju sadržaja."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Tekst samo s poveznicama",
              "DESCRIPTION": "Pretvori u čisti tekst, ali sačuvaj aktivne poveznice pri lijepljenju sadržaja."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Samo čisti tekst",
              "DESCRIPTION": "Ukloni svo oblikovanje i pretvori u čisti tekst pri lijepljenju sadržaja."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Височина на полето за отговор",
          "NOTE": "Задайте минималната височина на полето за отговор като процент от височината на екрана. Отнася се само за разговори по имейл.",
          "UPDATE_SUCCESS": "Настройката за височина на полето за отговор беше актуализирана успешно",
          "PERCENT_LABEL": "Височина (% от височината на екрана)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "По подразбиране",
              "DESCRIPTION": "Полето за отговор започва малко и се увеличава, докато пишете."
            },
            "CUSTOM": {
              "HEADING": "Персонализирано",
              "DESCRIPTION": "Полето за отговор винаги заема поне избрания процент от височината на екрана."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automatska navigacija na sljedeći razgovor",
        "NOTE": "Automatski se prebaci na sljedeći otvoreni razgovor nakon rješavanja trenutnog",
        "UPDATE_SUCCESS": "Postavka automatske navigacije uspješno ažurirana"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Формат на прегледа на имейли в списъка с разговори",
        "NOTE": "Изберете какво се показва в списъка с разговори за разговори от имейл кутии",
        "SUBJECT": "Тема",
        "SUBJECT_WITH_NOTE": "Тема и последното съобщение, ако е вътрешна бележка",
        "UPDATE_SUCCESS": "Настройката за преглед на имейли беше актуализирана успешно"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Onemogući tipkovničke prečace",
        "NOTE": "Isključi sve tipkovničke prečace u aplikaciji",
        "UPDATE_SUCCESS": "Postavka tipkovničkih prečaca uspješno ažurirana"
      },
      "FOLDER_ORDER": {
        "TITLE": "Redoslijed mapa",
        "NOTE": "Prilagodite redoslijed kojim se mape (prilagođeni pregledi) pojavljuju u bočnoj traci. Povucite i ispustite za promjenu redoslijeda.",
        "NO_FOLDERS": "Nije pronađena nijedna prilagođena mapa. Kreirajte mape za organizaciju vaših razgovora."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Konfiguracija bočne trake",
        "NOTE": "Prilagodite koji se odjeljci pojavljuju u bočnoj traci razgovora.",
        "SAVE_BUTTON": "Spremi konfiguraciju",
        "UPDATE_SUCCESS": "Konfiguracija bočne trake uspješno ažurirana",
        "UPDATE_ERROR": "Došlo je do greške pri ažuriranju konfiguracije bočne trake, pokušajte ponovno",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Svi razgovori",
          "ALL_CONVERSATIONS_DESC": "Prikaži stavku 'Svi razgovori' u bočnoj traci",
          "INBOX": "Sandučić",
          "INBOX_DESC": "Prikaži glavni sandučić s nepročitanim obavijestima",
          "CONVERSATION_GROUPS": "Spominjanja i neobrađeni",
          "CONVERSATION_GROUPS_DESC": "Prikaži grupe razgovora 'Spominjanja' i 'Neobrađeni'",
          "FOLDERS": "Mape",
          "FOLDERS_DESC": "Prikaži prilagođene preglede (mape) za organizirane razgovore",
          "TEAMS": "Timovi",
          "TEAMS_DESC": "Prikaži razgovore filtrirane po dodjelama tima",
          "CHANNELS": "Sandučići",
          "CHANNELS_DESC": "Prikaži razgovore filtrirane po sandučiću",
          "LABELS": "Oznake",
          "LABELS_DESC": "Prikaži razgovore filtrirane po oznakama"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Postavke telefona",
        "NOTE": "Unesite pristupne podatke za vaš PBX sustav.",
        "USERNAME": "Korisničko ime",
        "PASSWORD": "Lozinka",
        "SUBMIT": "Spremi",
        "USERNAME_INVALID": "Потребителското име може да съдържа само букви, цифри и . _ - + — без интервали и без имейл адрес.",
        "API": {
          "USERNAME_INVALID": "Потребителското име не е валидно SIP потребителско име. Използвайте само букви, цифри и . _ - + — без интервали и без имейл адрес.",
          "USERNAME_TAKEN": "Това потребителско име вече се използва от друг агент в този акаунт."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personal message signature",
        "DESCRIPTION": "Kreirajte jedinstveni potpis poruke koji se pojavljuje na kraju svake e-mail poruke koju pošaljete. Možete uključiti i umetnutu sliku.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Save message signature",
        "API_ERROR": "Couldn't save signature! Try again",
        "API_SUCCESS": "Signature saved successfully",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Message Signature",
        "ERROR": "Message Signature cannot be empty",
        "PLACEHOLDER": "Insert your personal message signature here."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Lozinka",
        "NOTE": "Updating your password would reset your logins in multiple devices.",
        "BTN_TEXT": "Promijeni lozinku"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Pristupni token",
        "NOTE": "This token can be used if you are building an API based integration",
        "COPY": "Kopiraj",
        "REGENERATE": "Regeneriraj",
        "REGENERATE_SUCCESS": "Pristupni token uspješno regeneriran. Ažurirajte sve integracije koje koriste stari token.",
        "REGENERATE_CONFIRM_TITLE": "Regenerirati pristupni token?",
        "REGENERATE_CONFIRM_MESSAGE": "Ovo će poništiti trenutni token. Sve integracije koje koriste stari token prestat će raditi."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome ekstenzija",
        "NOTE": "Instalirajte našu Chrome ekstenziju za bogate obavijesti o dolaznim telefonskim pozivima.",
        "INSTALL_BUTTON": "Instaliraj ekstenziju",
        "ALREADY_INSTALLED": "Ekstenzija instalirana"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Nijedno",
          "MINE": "Dodijeljeno",
          "ALL": "Sve",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Nijedno",
          "ASSIGNED": "Dodijeljeni razgovori",
          "ALL_CONVERSATIONS": "Svi razgovori"
        },
        "DEFAULT_TONE": {
          "TITLE": "Ton obavještenja:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Pročitaj više"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Email Notifications",
        "NOTE": "Update your email notification preferences here",
        "CONVERSATION_ASSIGNMENT": "Send email notifications when a conversation is assigned to me",
        "CONVERSATION_CREATION": "Send email notifications when a new conversation is created",
        "CONVERSATION_MENTION": "Send email notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in an assigned conversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "Email",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Kreirana je nova poruka u razgovoru bez dostupnog agenta",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Разрешаване на push известия по време на разговор",
        "TEST_PUSH": "Testiraj",
        "TESTING": "Testiranje...",
        "TEST_PUSH_DESCRIPTION": "Pošaljite testne obavijesti za provjeru postavki",
        "TEST_NOTIFICATION_ERROR": "Slanje testne obavijesti nije uspjelo. Pokušajte ponovno.",
        "TEST_LOCAL_TITLE": "Testna obavijest (lokalno)",
        "TEST_LOCAL_BODY": "Ovo je lokalna obavijest preglednika. Ako vidite ovo, obavijesti preglednika rade!"
      },
      "API": {
        "UPDATE_SUCCESS": "Your notification preferences are updated successfully",
        "UPDATE_ERROR": "There is an error while updating the preferences, please try again"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push Notifications",
        "NOTE": "Update your push notification preferences here",
        "CONVERSATION_ASSIGNMENT": "Send push notifications when a conversation is assigned to me",
        "CONVERSATION_CREATION": "Send push notifications when a new conversation is created",
        "CONVERSATION_MENTION": "Send push notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in an assigned conversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "You have enabled push for this browser.",
        "REQUEST_PUSH": "Enable push notifications",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilna slika"
      },
      "NAME": {
        "LABEL": "Your full name",
        "ERROR": "Please enter a valid full name",
        "PLACEHOLDER": "Please enter your full name"
      },
      "DISPLAY_NAME": {
        "LABEL": "Display name",
        "ERROR": "Please enter a valid display name",
        "PLACEHOLDER": "Please enter a display name, this would be displayed in conversations"
      },
      "POSITION": {
        "LABEL": "Pozicija",
        "ERROR": "Unesite ispravnu poziciju",
        "PLACEHOLDER": "Unesite svoju poziciju"
      },
      "CUSTOM_LINE": {
        "LABEL": "Prilagođeni redak",
        "ERROR": "Unesite ispravan prilagođeni redak",
        "PLACEHOLDER": "Unesite svoj prilagođeni redak"
      },
      "AVAILABILITY": {
        "LABEL": "Availability",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Busy",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL": {
        "LABEL": "Your email address",
        "ERROR": "Please enter a valid email address",
        "PLACEHOLDER": "Please enter your email address, this would be displayed in conversations"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Current password",
        "ERROR": "Please enter the current password",
        "PLACEHOLDER": "Please enter the current password"
      },
      "PASSWORD": {
        "LABEL": "New password",
        "ERROR": "Please enter a password of length 6 or more",
        "PLACEHOLDER": "Please enter a new password"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirm new password",
        "ERROR": "Confirm password should match the password",
        "PLACEHOLDER": "Please re-enter your new password"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Change",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Prijavi grešku",
    "SELECTOR_SUBTITLE": "Select an account from the following list",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Prijavi grešku",
    "DESCRIPTION_LABEL": "Opis problema",
    "DESCRIPTION_PLACEHOLDER": "Opišite problem na koji ste naišli...",
    "SUBMIT": "Pošalji prijavu",
    "SUBMITTING": "Slanje...",
    "CANCEL": "Odustani",
    "SUCCESS": "Prijava greške uspješno poslana. Hvala!",
    "ERROR": "Slanje prijave greške nije uspjelo. Pokušajte ponovno.",
    "VALIDATION_ERROR": "Opišite problem prije slanja"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "days trial remaining.",
    "TRAIL_BUTTON": "Buy Now",
    "DELETED_USER": "Deleted User",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Your account is suspended. Please reach out to the support team for more information."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copy",
      "CODEPEN": "Otvori u CodePenu",
      "COPY_SUCCESSFUL": "Copied to clipboard"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Show More",
      "SHOW_LESS": "Show Less"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Download",
      "UPLOADING": "Prenosim...",
      "INSTAGRAM_STORY_UNAVAILABLE": "This story is no longer available.",
      "RECORDING_UNAVAILABLE": "Този запис вече не е наличен.",
      "DELETE_RECORDING": {
        "BUTTON": "Изтриване на записа на разговора",
        "TITLE": "Да се изтрие ли записът на разговора?",
        "DESCRIPTION": "Всички записи на този разговор ще бъдат изтрити окончателно от телефонната централа и не могат да бъдат възстановени. Транскрипцията и резюмето на разговора се запазват.",
        "CONFIRM": "Изтриване",
        "SUCCESS": "Записът на разговора е изтрит",
        "ERROR": "Записът на разговора не можа да бъде изтрит. Моля, опитайте отново."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Submit"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verifying...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Add Inbox"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Currently viewing:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Conversations",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Svi razgovori",
    "MENTIONED_CONVERSATIONS": "Mentions",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Unattended",
    "REPORTS": "Reports",
    "SETTINGS": "Settings",
    "CONTACTS": "Contacts",
    "DATA_ASSISTANT": "Podatkovni asistent",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Home",
    "AGENTS": "Agenti",
    "AGENT_BOTS": "Botovi",
    "AUDIT_LOGS": "Audit Logovi",
    "WHATSAPP_TEMPLATES": "Шаблони на WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Inboxes",
    "NOTIFICATIONS": "Notifications",
    "CANNED_RESPONSES": "Canned Responses",
    "INTEGRATIONS": "Integrations",
    "PROFILE_SETTINGS": "Postavke profila",
    "ACCOUNT_SETTINGS": "Account Settings",
    "APPLICATIONS": "Applications",
    "LABELS": "Labels",
    "CUSTOM_ATTRIBUTES": "Custom Attributes",
    "AUTOMATION": "Automation",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "Folders",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "All Contacts",
    "TAGGED_WITH": "Tagged with",
    "NEW_LABEL": "New label",
    "NEW_TEAM": "New team",
    "NEW_INBOX": "New inbox",
    "REPORTS_CONVERSATION": "Conversations",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campaigns",
    "ONGOING": "Ongoing",
    "ONE_OFF": "One off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenti",
    "REPORTS_LABEL": "Labels",
    "REPORTS_INBOX": "Inbox",
    "REPORTS_TEAM": "Tim",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Pregled",
    "WALLBOARD_QUEUES": "Redovi čekanja",
    "WALLBOARD_AGENTS": "Pregled agenata",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Izvještaji",
    "NO_WAITING_CALLERS": "nema pozivatelja na čekanju",
    "WAITING_CALLERS": "{count} pozivatelja na čekanju",
    "SET_AVAILABILITY_TITLE": "Postavi sebe kao",
    "SET_YOUR_AVAILABILITY": "Set your availability",
    "AVAILABILITY_IMPERSONATING": "Заключено при вход като този потребител",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Novi razgovor",
    "DRAFT": "Skica",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Pregled",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Centar za pomoć",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "Postavke",
      "DICTIONARY": "Речник"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Pročitaj članke"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blokirane domene i kontakti",
    "DESCRIPTION": "Popis blokiranih e-mail domena za ovaj račun.",
    "NO_BLOCKED_DOMAINS": "Nije pronađena nijedna blokirana domena.",
    "BLOCKED_CONTACTS_BTN": "Blokirani kontakti"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Naplata",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Trenutni plan",
      "PLAN_NOTE": "You are currently subscribed to the **{plan}** plan with **{quantity}** licenses",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Upravljanje pretplatom",
      "DESCRIPTION": "View your previous invoices, edit your billing details, or cancel your subscription.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Trebate pomoć?",
      "DESCRIPTION": "Do you face any issues in billing? We are here to help.",
      "BUTTON_TXT": "Čavrljajte s nama"
    },
    "NO_BILLING_USER": "Your billing account is being configured. Please refresh the page and try again."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Опа! Не открихме нито един акаунт. Моля, създайте нов акаунт, за да продължите.",
    "NEW_ACCOUNT": "Novi račun",
    "SELECTOR_SUBTITLE": "Kreirajte novi račun",
    "API": {
      "SUCCESS_MESSAGE": "Račun uspješno kreiran",
      "EXIST_MESSAGE": "Račun već postoji",
      "ERROR_MESSAGE": "Could not connect to chat Server, Please try again later"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Naziv tvrtke",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Pošalji",
      "CANCEL": "Odustani"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Vidi sve skraćenice",
    "TITLE": {
      "OPEN_CONVERSATION": "Otvori razgovor",
      "RESOLVE_AND_NEXT": "Resolve and move to next",
      "NAVIGATE_DROPDOWN": "Navigate dropdown items",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Toggle Sidebar",
      "GO_TO_REPORTS_SIDEBAR": "Go to Reports sidebar",
      "MOVE_TO_NEXT_TAB": "Move to next tab in conversation list",
      "GO_TO_SETTINGS": "Idi na postavke",
      "SWITCH_TO_PRIVATE_NOTE": "Switch to Private Note",
      "SWITCH_TO_REPLY": "Switch to Reply",
      "TOGGLE_SNOOZE_DROPDOWN": "Toggle snooze dropdown",
      "AI_ASSIST_MENU": "AI pomoć",
      "AI_ASSIST_GRAMMAR": "Ispravi gramatiku",
      "AI_ASSIST_UNIFY_LANG": "Ujednači jezik poruke"
    }
  }
}
